import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../assets/styles/AppHome/BusinessInsightCard.module.scss';
import Tooltip from '@mui/material/Tooltip';

const propTypes = {
	title: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	amount: PropTypes.string,
	styleClass: PropTypes.any,
	info: PropTypes.string,
};

const defaultProps = {
	title: '',
	loading: false,
	onClick: () => { },
	disabled: false,
	amount: '',
	styleClass: '',
};

const BusinessInsightComponent = ({ title, amount, styleClass, info, onClick, ...props }) => {
	return (
		<Tooltip title={info} arrow placement="top-start" componentsProps={{
			tooltip: {
				sx: {
					position: "absolute",
					top: "2",
					backgroundColor: "#ffffff",
					color: "#333333",
					fontSize: "1.5rem",
					minWidth: "25rem",
					padding: "1rem",
					zIndex: "1",
					height: "8rem",
				},
			},
		}}>
			<div onClick={onClick} className={`${styles.bi__card} ${styleClass}`}>
				<div className={styles.bi__card__value}>{amount}</div>
				<div className={styles.bi__card__title}>{title}</div>
			</div>
		</Tooltip>
	);
};

export default BusinessInsightComponent;
